import { cancerscreenSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/cancerscreen.validation-set';
import { carrierSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/carrier.validation-set';
import { galleriSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/galleri.validation-set';
import { monoSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/mono.validation-set';
import { negSingleCarrierSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/neg-single-carrier.validation-set';
import { niptSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/nipt.validation-set';
import { nipptSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/nippt.validation-set';
import { paternitySampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/paternity.validation-set';
import { rhSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/rh.validation-set';
import { venisafeSampleValidationSet } from '@app/modules/service-data/components/sample/sample-dialog/validation-sets/venisafe.validation-set';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { DataInputType } from '@core/core.types';
import { otherSampleValidationSet } from './validation-sets/other.validation-set';

export const sampleValidationGroups: {
  [groupKey: string]: ValidationPair;
} = {
  [DataInputType.NIPT]: niptSampleValidationSet,
  [DataInputType.NIPPT]: nipptSampleValidationSet,
  [DataInputType.MONO]: monoSampleValidationSet,
  [DataInputType.RH]: rhSampleValidationSet,
  [DataInputType.CARRIER]: carrierSampleValidationSet,
  [DataInputType.CANCERSCREEN]: cancerscreenSampleValidationSet,
  [DataInputType.GALLERI]: galleriSampleValidationSet,
  [DataInputType.PATERNITY]: paternitySampleValidationSet,
  [DataInputType.NEGSINGLECARRIER]: negSingleCarrierSampleValidationSet,
  [DataInputType.VENISAFE]: venisafeSampleValidationSet,
  [DataInputType.VENISAFEMATERNA]: venisafeSampleValidationSet,
  [DataInputType.OTHER]: otherSampleValidationSet,
};
